import { combineReducers } from 'redux';

import apiError from './apiError';
import data from './data';
import isLoading from './isLoading';

/**
 * @typedef {{
 *   isLoading: boolean,
 *   apiError: string,
 *   data: Record<string, string[]>
 * }} AuditModelUIDetailsFieldsReducer
 */

export default combineReducers({
  data,
  isLoading,
  apiError,
});
